export const brightGreen = "#8be200";
export const linkGreen = "#88e400";
export const purple = "#8f68dd";
export const removeRed = "#ff2200";
export const cyan = "#00CCCC";
export const lightCyan = "#D5FEF7";

//cyan
export const cyan50 = "#E0F8F8";
export const cyan100 = "#BFF6F6";
export const cyan200 = "#9EF4F3";
export const cyan300 = "#4FE0E0";
export const cyan400 = "#00CCCC";
export const cyan500 = "#01AFB1";
export const cyan600 = "#019397";
export const cyan700 = "#00767C";
export const cyan800 = "#003B3E";
export const cyan900 = "#001E1F";

//green
export const green900 = "#001F06"
export const green800 = "#003E0C";
export const green700 = "#007C19";
export const green600 = "#2DA145";
export const green500 = "#FFAB22";
export const green400 = "#86E99A";
export const green300 = "#FFC54C";
export const green200 = "#B5F6C2";
export const green100 = "#C9FBD3";
export const green50 = "#DDFFE4";

//design language orange";
export const orange900 = "B54B00";
export const orange800 = "#ff6900";
export const orange700 = "#ff8800";
export const orange600 = "#FF9A11";
export const orange500 = "#ffbd33";
export const orange400 = "#ffbd33";
export const orange300 = "#EF634D";
export const orange200 = "#ffcd65";
export const orange100 = "#FFE09E";
export const orange50 = "#FFF2D6";

//design language red
export const red900 = "#460A00";
export const red800 = "#8b1400";
export const red700 = "#ba1900";
export const red600 = "#CB2A11";
export const red500 = "#DC3B22";
export const red400 = "#ED4B33";
export const red300 = "#f17a66";
export const red200 = "#f17a66";
export const red100 = "#F7A89B";
export const red50 = "#FDD6D0";

//design language greyscale
export const black = "#000000";
export const grey900 = "#111111";
export const grey800 = "#232323";
export const grey700 = "#404040";
export const grey600 = "#5d5d5d";
export const grey500 = "#979797";
export const grey400 = "#bebebe";
export const grey300 = "#b9b9b9";
export const grey200 = "#dcdcdc";
export const grey100 = "#eeeeee";
export const grey50 = "#F3f3f3";
export const white = "#fff";

//padding
const noPad = "0";
const xxSmallPad = "1px";
const xSmallPad = "2px";
const smallPad = "4px";
const mediumPad = "8px";
const mediumLargePad = "12px";
const largePad = "16px";
const xLargePad = "24px";
const xxLargePad = "36px";
const smallLayoutPad = "56px";
const mediumLayoutPad = "84px";
const largeLayoutPad = "128px";

//border radius
const smallBorderRadius = "2px";
const smallMediumBorderRadius = "3px";
const mediumBorderRadius = "4px";
const mediumLargeBorderRadius = "8px";
const largeBorderRadius = "16px";
const xLargeBorderRadius = "24px";
const circleBorderRadius = "100%";

//shadows
const shadowColor = " rgba(0, 0, 0, .20)";
const baseLayerShadow = " 0 2px 2px rgba(0, 0, 0, .25)";
const firstLayerShadow = " 0 4px 12px rgba(0, 0, 0, .25)";
const secondLayerShadow = " 0 8px 20px rgba(0, 0, 0, .17)";
const thirdLayerShadow = " 0 8px 24px rgba(0, 0, 0, .10)";
const focusShadow = " 0 0 0 4px rgba(const grey400, .2)";
const invalidFocusShadow = " 0 0 0 4px rgba($orange, .4)";

//fonts
const fontFamily = "roboto, filson-soft, sans-serif";

//App font sizes
const xxxSmallFont = "8px";
const xxSmallFont = "10px";
const xSmallFont = "12px";
const smallFont = "14px";
const mediumFont = "16px";
const largeFont = "20px";
const xLargeFont = "24px";

//Display fonts
const smallDisplayFont = "28px";
const mediumDisplayFont = "32px";
const largeDisplayFont = "40px";
const xLargeDisplayFont = "48px";
const xxLargeDisplayFont = "56px";

//font weights
const thinFontWeight = "100";
const regularFontWeight = "400";
const mediumFontWeight = "500";
const boldFontWeight = "700";

//letterSpacing
const xSmallLetterSpacing = ".25px";
const smallLetterSpacing = "1px";
const smallMediumLetterSpacing = "1.2px";
const mediumLetterSpacing = "1.5px";
const largeLetterSpacing = "2px";

//lineHeight
const squareLineHeight = "1";
const compactLineHeight = "1.2";
const regularLineHeight = "1.4";
const spaciousLineHeight = "1.6";

export const golfstatusTypography = {
  fontFamily,

  //App font sizes
  xxxSmallFont,
  xxSmallFont,
  xSmallFont,
  smallFont,
  mediumFont,
  largeFont,
  xLargeFont,

  //Display fonts
  smallDisplayFont,
  mediumDisplayFont,
  largeDisplayFont,
  xLargeDisplayFont,
  xxLargeDisplayFont,

  //font weights
  thinFontWeight,
  regularFontWeight,
  mediumFontWeight,
  boldFontWeight,

  //letterSpacing
  xSmallLetterSpacing,
  smallLetterSpacing,
  smallMediumLetterSpacing,
  mediumLetterSpacing,
  largeLetterSpacing,

  //lineHeight
  squareLineHeight,
  compactLineHeight,
  regularLineHeight,
  spaciousLineHeight
};

export const golfstatusBorders = {
  smallBorderRadius,
  smallMediumBorderRadius,
  mediumBorderRadius,
  mediumLargeBorderRadius,
  largeBorderRadius,
  xLargeBorderRadius,
  circleBorderRadius
};

export const golfstatusShadows = {
  shadowColor,
  baseLayerShadow,
  firstLayerShadow,
  secondLayerShadow,
  thirdLayerShadow,
  focusShadow,
  invalidFocusShadow
};

export const golfstatusSpacing = {
  noPad,
  xxSmallPad,
  xSmallPad,
  smallPad,
  mediumPad,
  mediumLargePad,
  largePad,
  xLargePad,
  xxLargePad,
  smallLayoutPad,
  mediumLayoutPad,
  largeLayoutPad
};

export const golfstatusColors = {
  brightGreen,
  linkGreen,
  purple,
  removeRed,
  cyan,
  lightCyan,
  cyan50,
  cyan100,
  cyan200,
  cyan300,
  cyan400,
  cyan500,
  cyan600,
  cyan700,
  cyan800,
  cyan900,
  green900,
  green800,
  green700,
  green600,
  green500,
  green400,
  green300,
  green200,
  green100,
  green50,
  orange900,
  orange800,
  orange700,
  orange600,
  orange500,
  orange400,
  orange300,
  orange200,
  orange100,
  orange50,
  red900,
  red800,
  red700,
  red600,
  red500,
  red400,
  red300,
  red200,
  red100,
  red50,
  black,
  grey900,
  grey800,
  grey700,
  grey600,
  grey500,
  grey400,
  grey300,
  grey200,
  grey100,
  grey50,
  white
};

export const defaultTheme = {
  primary: {
    light: {
      color: grey800
    },
    dark: {
      color: white
    }
  },
  secondary: {
    light: {
      color: cyan700
    },
    dark: {
      color: cyan200
    }
  },
  primaryContainer: {
    light: {
      backgroundColor: grey800,
      color: white
    },
    dark: {
      backgroundColor: white,
      color: grey800
    }
  },
  secondaryContainer: {
    light: {
      backgroundColor: cyan700,
      color: white
    },
    dark: {
      backgroundColor: cyan700,
      color: white
    }
  },
  secondaryContainerHigh: {
    light: {
      backgroundColor: cyan700,
      color: white
    },
    dark: {
      backgroundColor: cyan200,
      color: cyan900
    }
  },
  background: {
    light: {
      backgroundColor: white,
      color: grey800
    },
    dark: {
      backgroundColor: black,
      color: white
    }
  },
  surface: {
    light: {
      backgroundColor: white,
      color: grey800
    },
    dark: {
      backgroundColor: grey900,
      color: white
    }
  },
  surfaceDim: {
    light: {
      backgroundColor: grey200,
      color: grey800
    },
    dark: {
      backgroundColor: grey900,
      color: grey100
    }
  },
  surfaceBright: {
    light: {
      backgroundColor: white,
      color: grey800
    },
    dark: {
      backgroundColor: grey700,
      color: white
    }
  },
  surfaceContainerLow: {
    light: {
      backgroundColor: white,
      color: grey800
    },
    dark: {
      backgroundColor: grey900,
      color: white
    }
  },
  surfaceContainerLowest: {
    light: {
      backgroundColor: white,
      color: grey800
    },
    dark: {
      backgroundColor: black,
      color: grey100
    }
  },
  surfaceContainerHigh: {
    light: {
      backgroundColor: grey50,
      color: grey800
    },
    dark: {
      backgroundColor: grey800,
      color: white
    }
  },
  surfaceContainerHigest: {
    light: {
      backgroundColor: grey100,
      color: grey800
    },
    dark: {
      backgroundColor: grey700,
      color: white
    }
  },
  surfaceVariant: {
    light: {
      backgroundColor: grey50,
      color: grey800
    },
    dark: {
      backgroundColor: grey800,
      color: grey100
    }
  },
  outline: {
    light: {
      borderColor: grey700
    },
    dark: {
      borderColor: white
    }
  },
  outlineVariant: {
    light: {
      borderColor: grey100
    },
    dark: {
      borderColor: grey800
    }
  },
  scrim: {
    light: {
      backgroundColor: black,
      color: white
    },
    dark: {
      backgroundColor: black,
      color: white
    }
  },
  error: {
    light: {
      color: orange400
    },
    dark: {
      color: orange200
    }
  },
  errorContainer: {
    light: {
      backgroundColor: orange200,
      color: grey800
    },
    dark: {
      backgroundColor: orange400,
      color: grey800
    }
  },
  tertiary: {
    light: {
      color: green400
    },
    dark: {
      color: green200
    }
  },
  tertiaryContainer: {
    light: {
      backgroundColor: green200,
      color: grey800
    },
    dark: {
      backgroundColor: green400,
      color: grey800
    }
  }
};

const applyPadding = (pad, side) => {
  const padding = {
    top: {
      paddintTop: pad,
      boxSizing: "border-box"
    },
    right: {
      paddingRight: pad,
      boxSizing: "border-box"
    },
    bottom: {
      paddingBottom: pad,
      boxSizing: "border-box"
    },
    left: {
      paddingLeft: pad,
      boxSizing: "border-box"
    },
    vertical: {
      paddingTop: pad,
      paddingBottom: pad,
      boxSizing: "border-box"
    },
    horizontal: {
      paddingLeft: pad,
      paddingRight: pad,
      boxSizing: "border-box"
    },
    all: {
      paddingLeft: pad,
      paddingRight: pad,
      paddingTop: pad,
      paddingBottom: pad,
      boxSizing: "border-box"
    }
  };

  if (side) {
    return padding?.[side];
  }
  return padding;
};

export const defaultPadding = {
  noPad: {
    ...applyPadding(noPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(noPad, side);
    }
  },
  xxSmallPad: {
    ...applyPadding(xxSmallPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(xxSmallPad, side);
    }
  },
  xSmallPad: {
    ...applyPadding(xSmallPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(xSmallPad, side);
    }
  },
  smallPad: {
    ...applyPadding(smallPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(smallPad, side);
    }
  },
  mediumPad: {
    ...applyPadding(mediumPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(mediumPad, side);
    }
  },
  mediumLargePad: {
    ...applyPadding(mediumLargePad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(mediumLargePad, side);
    }
  },
  largePad: {
    ...applyPadding(largePad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(largePad, side);
    }
  },
  xLargePad: {
    ...applyPadding(xLargePad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(xLargePad, side);
    }
  },
  xxLargePad: {
    ...applyPadding(xxLargePad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(xxLargePad, side);
    }
  },
  smallLayoutPad: {
    ...applyPadding(smallLayoutPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(smallLayoutPad, side);
    }
  },
  mediumLayoutPad: {
    ...applyPadding(mediumLayoutPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(mediumLayoutPad, side);
    }
  },
  largeLayoutPad: {
    ...applyPadding(largeLayoutPad, "all"),
    boxSizing: "border-box",
    apply: side => {
      return applyPadding(largeLayoutPad, side);
    }
  },
  emptyListPad: {
    padding: `${largeLayoutPad} ${xLargePad}`,
    boxSizing: "border-box"
  }
};

export const defaultGapping = {
  noGap: {
    gap: noPad,
    boxSizing: "border-box"
  },
  xxSmallGap: {
    gap: xxSmallPad,
    boxSizing: "border-box"
  },
  xSmallPad: {
    gap: xSmallPad,
    boxSizing: "border-box"
  },
  smallGap: {
    gap: smallPad,
    boxSizing: "border-box"
  },
  mediumGap: {
    gap: mediumPad,
    boxSizing: "border-box"
  },
  mediumLargeGap: {
    gap: mediumLargePad,
    boxSizing: "border-box"
  },
  largeGap: {
    gap: largePad,
    boxSizing: "border-box"
  },
  xLargeGap: {
    gap: xLargePad,
    boxSizing: "border-box"
  },
  xxLargeGap: {
    gap: xxLargePad,
    boxSizing: "border-box"
  },
  smallLayoutGap: {
    gap: smallLayoutPad,
    boxSizing: "border-box"
  },
  mediumLayoutGap: {
    gap: mediumLayoutPad,
    boxSizing: "border-box"
  },
  largeLayoutGap: {
    gap: largeLayoutPad,
    boxSizing: "border-box"
  }
};

export const defaultBorders = {
  smallBorderRadius: { borderRadius: smallBorderRadius },
  smallMediumBorderRadius: { borderRadius: smallMediumBorderRadius },
  mediumBorderRadius: { borderRadius: mediumBorderRadius },
  mediumLargeBorderRadius: { borderRadius: mediumLargeBorderRadius },
  largeBorderRadius: { borderRadius: largeBorderRadius },
  xLargeBorderRadius: { borderRadius: xLargeBorderRadius },
  circleBorderRadius: { borderRadius: circleBorderRadius },
  primaryBorder: {
    borderColor: grey200,
    borderWidth: "1px",
    borderStyle: "solid",
    themed: (mode) => {
      return mode === "light" ?  {borderColor: grey200,
      borderWidth: "1px",
      borderStyle: "solid"} : {borderColor: grey700,
        borderWidth: "1px",
        borderStyle: "solid"}
    }
  }
};

export const defaultShadows = {
  baseLayerShadow: { boxShadow: baseLayerShadow },
  firstLayerShadow: { boxShadow: firstLayerShadow },
  secondLayerShadow: { boxShadow: secondLayerShadow },
  thirdLayerShadow: { boxShadow: thirdLayerShadow },
  focusShadow: { boxShadow: focusShadow },
  invalidFocusShadow: { boxShadow: invalidFocusShadow }
};

export const defaultTypography = {
  primary: {
    fontSize: largeFont,
    fontWeight: boldFontWeight
  },
  secondary: {
    fontSize: largeFont,
    opacity: "0.7"
  },
  tertiary: {
    fontSize: smallFont,
    opacity: "0.7"
  },
  header: {
    fontSize: largeFont,
    fontWeight: boldFontWeight
  },
  headline1: {
    fontSize: mediumDisplayFont,
    fontWeight: boldFontWeight,
    lineHeight: squareLineHeight
  },
  headline2: { fontSize: xLargeFont, fontWeight: boldFontWeight, lineHeight: squareLineHeight },
  headline3: { fontSize: largeFont, fontWeight: boldFontWeight, lineHeight: compactLineHeight },
  headline4: { fontSize: mediumFont, fontWeight: boldFontWeight, lineHeight: compactLineHeight },
  headline5: { fontSize: smallFont, fontWeight: boldFontWeight, lineHeight: compactLineHeight },
  mediumBoldBody: {fontSize: mediumFont, fontWeight: boldFontWeight, lineHeight: regularLineHeight},
  mediumBody: {fontSize: mediumFont, fontWeight: regularFontWeight, lineHeight: regularLineHeight},
  xSmallBodyBold: {fontSize: xSmallFont, fontWeight: boldFontWeight, lineHeight: regularLineHeight},
  xSmallBody: {fontSize: xSmallFont, fontWeight: regularFontWeight, lineHeight: regularLineHeight},
  body: { fontSize: smallFont, fontWeight: boldFontWeight, lineHeight: regularLineHeight },
  bodyRegular: { fontSize: smallFont, fontWeight: regularFontWeight, lineHeight: regularLineHeight, withOpacity : (opacity) => {
    return { fontSize: smallFont, lineHeight: regularLineHeight, fontWeight: regularFontWeight, opacity: opacity ?? .7}
  } },
  overLine1: {
    fontSize: xSmallFont,
    letterSpacing: smallMediumLetterSpacing,
    fontWeight: boldFontWeight
  },
  overline2: {
    fontSize: xxSmallFont,
    letterSpacing: mediumLetterSpacing,
    fontWeight: boldFontWeight
  },
  overline3: { fontSize: xxxSmallFont, fontWeight: boldFontWeight },
  displayLarge: { fontSize: xLargeDisplayFont, fontWeight: boldFontWeight },
  displaySmall: { fontSize: mediumDisplayFont, fontWeight: boldFontWeight },
  capitalize: {
    textTransform: "capitalize"
  },
  uppercase: {
    textTransform: "uppercase"
  },
  lowercase: {
    textTransform: "lowercase"
  },
};

export const defaultLayouts = {
  vStack: {
    display: "inline-flex",
    flexDirection: "column",
    /**
     *
     * @param {string} horizontal [flex-start, flex-end, center, stretch]
     * @param {string} vertical [flex-start, flex-end, center, stretch]
     * @returns
     */
    align: (horizontal, vertical) => {
      return {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: horizontal,
        justifyContent: vertical
      };
    }
  },
  hStack: {
    display: "inline-flex",
    flexDirection: "row",
    /**
     *
     * @param {string} horizontal [flex-start, flex-end, center, stretch]
     * @param {string} vertical [flex-start, flex-end, center, stretch]
     * @returns
     */
    align: (horizontal, vertical) => {
      return {
        display: "inline-flex",
        flexDirection: "row",
        alignItems: vertical,
        justifyContent: horizontal
      };
    }
  },
  fullWidth: {
    width: "100%"
  },
  fullHeight: {
    height: "100%"
  },
  fill: {
    height: "100%",
    width: "100%"
  },
  stickyBottom: {
    width: "100%",
    position: "sticky",
    bottom: "0"
  },
  stickyTop: {
    width: "100%",
    position: "sticky",
    top: "0"
  },
  hidden: {
    display: "none"
  },
  hero: {
    image: (url, minHeight) => {
      return {
        minHeight: minHeight ? minHeight : "500px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${url ?? ""})`
      };
    }
  },
  blurBackground: {
    backdropFilter: "blur(8px)"
  }
};

/**
 * merged theme from the default theme
 *
 * @param {defaultTheme} customTheme theme stylings that will overrride the default theme
 * @return {defaultTheme} new theme from default
 */
export const mergedTheme = customTheme => {
  return { ...defaultTheme, ...customTheme };
};

/**
 * create a gradient from an array of colors
 *
 * @param {Array.<string>} colors theme stylings that will overrride the default theme
 * @return {object} a style definition with that gradient as a background
 */
export const gradientBackground = colors => {
  return { background: `linear-gradient(to right, ${colors?.join?.(",")})` };
};

/**
 * inverts the background and the color definition for the given style
 *
 * @param {object} style the style definition that you want to invert
 * @return {object} a style definition with that gradient as a background
 */
export const invertSyle = style => {
  return { color: style?.backgroundColor, backgroundColor: style?.color };
};


/**
 * inverts the background and the color definition for the given style
 *
 * @param {string} hex the hex value for the color without the alpha channel
 *  @param {number} alpha the alpha value from 0 to 1
 * 
 * @return {object} a style definition with that gradient as a background
 */
export const addAlphaChannel = (hex, alpha = 1) =>{
  if(!hex){
    return hex
  }
  // Remove the # if present
  hex = hex.replace(/^#/, '');

  // Check if the hex code is valid
  if (hex.length !== 3 && hex.length !== 6) {
    return hex
  }

  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  // Parse the hex values into decimal
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Return the RGB values
  return `rgba(${r}, ${g}, ${b}, ${alpha})` ;
}